<template>
<div>
<v-container fluid>
	  <h1>Notifications Settings</h1>
	  <v-spacer />
      <v-card class = "card-curvey">
        <v-flex xs12>
        	<v-form>
        		<label>Notification Title</label>
        		<v-text-field
        		  v-model = "notificationsInput.notification_title"
        		  :disabled="!notificationSettings"
        		  placeholder = "Notification Title"
        		  outline />
        		<label>Server Key</label>
        		<v-text-field
        		  v-model = "notificationsInput.server_key"
        		  :disabled="!notificationSettings"
        		  placeholder = "Server Key"
        		  outline />
        	</v-form>
        </v-flex>
        <v-layout row wrap>
        	<v-spacer />
        	<v-btn :disabled="!notificationSettings" @click="updateNotifications" color ="primary">Save</v-btn>
        </v-layout>
    </v-card>

  </v-container>
	</div>
</template>

<script>
import FacebookNotificationsConfig from './FacebookNotificationsConfig'
import TwitterNotificationsConfig from './TwitterNotificationsConfig'
import SmoochNotificationsConfig from './SmoochNotificationsConfig'
import ChannelNotificationConfig from './ChannelNotificationConfig'
import SupportedPlatforms from '../../block-build/blocks/SupportedPlatforms.vue'
export default {
  name: 'ListAppNotifications',
  components: {
  	SupportedPlatforms,
  	ChannelNotificationConfig
  },
  data () {
    return {
    	twitterApps: null,
    	allApps: null,
    	configurationsDialog: false,
    	appToConfigure: {
    		props: null,
    		data: null
    	},
    	configurableApps: [ 'facebook', 'twitter', 'smooch' ],
    	headers: [
        {
          text: 'App',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        { text: 'Channel', value: 'app', align: 'center' },
        { text: 'Actions', value: 'app' },
      ],
      notificationsInput: {
      	notification_title: '',
      	server_key: ''
      },
      notificationSettings: null,
      channels: {
      	facebook: {
      		attrs: ["page_id", "app_secret", "access_token", "verify_token", "name", "image"],
      		color: 'blue darken-2'
      	},
      	twitter: {
      		attrs: ["env_name", "screen_name", "consumer_key", "consumer_secret", "access_token", "access_token_secret"],
      		color: 'blue'
      	},
      	tyntec: {
      		attrs: ["app_id", "api_key"],
      		color: 'amber darken-2'
      	},
      	smooch: {
      		attrs: ["app_id", "key_id", "secret", "service_url"],
      		color: 'purple darken-2'
      	},
      }
    }
  },
  computed: {
  	botId() {
  		return this.$store.state.bot.botId
  	}
  },
  watch: {
  	configurationsDialog(val) {
  		if(!val) {
  			this.appToConfigure = null
  		}
  	}
  },
  mounted() {
  	this.getApps()
  	this.getNotificationSettings()
  },
  methods: {
  	async getApps() {
  		this.$store.dispatch('setLoader', true)
  		this.$http_chat.get(`/bots/${this.botId}/apps`).then(({ data })=>{
  			this.$store.dispatch('setLoader', false)
  			this.allApps = data.data
  		}).catch((err) =>{
  		  this.$store.dispatch('setErrorMessage', true)
          this.$store.dispatch('setLoader', false)
  		})
  	},
  	async getNotificationSettings() {
  		this.notificationSettings = null
  		this.$store.dispatch('setLoader', true)
  		this.$http_chat.get(`/bots/${this.botId}/notification-settings`).then(({ data })=>{
  			this.$store.dispatch('setLoader', false)
  			this.notificationSettings = data.data
        this.notificationsInput = data.data
  		}).catch((err) =>{
  		  this.$store.dispatch('setErrorMessage', 'Could not get notifications setting for this bot.')
          this.$store.dispatch('setLoader', false)
  		})
  	},
  	startConfiguration(app) {
  		this.appToConfigure = null
  		if(!this.channels[app.provider]) {
  			return
  		}
  		const result = { data: null, props: null }
  		result.props = { id: app.id, channel: app.provider, ...this.channels[app.provider] }
  		result.data = app
  		this.appToConfigure = result
  		this.configurationsDialog = true
  	},
  	handleUpdateSuccess() {
  		this.configurationsDialog = false
  		this.getApps()
  	},
  	updateNotifications() {
  		this.$store.dispatch('setLoader', true)
  		this.$http_chat.put(`/bots/${this.botId}/notification-settings`, this.notificationsInput).then(({ data })=>{
  			this.$store.dispatch('setLoader', false)
  			 this.$store.dispatch('setSnackbar', {
              text: `Updated Successfully`,
              color: 'success'
            })
  			this.getNotificationSettings()
  		}).catch((err) =>{
  		  this.$store.dispatch('setErrorMessage', true)
          this.$store.dispatch('setLoader', false)
  		})
  	}
  }
}
</script>

<style lang="css" scoped>
</style>
